// Deploy-Marker 2026-10-27: löst einen Netlify-Branch-Deploy aus.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/main.css";
import { patchElectronNativeDialogs } from "@/lib/electronDialog";
import { installSelectSearchFieldOnFocus } from "@/lib/selectSearchFieldOnFocus";
import { App } from "@/App";

patchElectronNativeDialogs();
installSelectSearchFieldOnFocus();

// Nach Deploy: fehlende Lazy-Chunks → einmal hart neu laden.
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
